<template>
  <div id="app" :class="{ opacity: showDropLayer }">
    <router-view />
    <div
      class="global-wraper"
      v-if="authenticated"
      v-show="plugin.showGlobalUploader || plugin.showGlobalQueue"
    >
      <GlobalQueue v-show="plugin.showGlobalQueue"></GlobalQueue>
      <GlobalUploader v-show="plugin.showGlobalUploader"></GlobalUploader>
    </div>
    <div v-show="showDropLayer" id="dropLayer">上传文件/文件夹到当前目录下</div>
  </div>
</template>
<script>
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      showDropLayer: false,
      plugin: {
        showGlobalUploader: false,
        showGlobalQueue: false,
      },
    };
  },
  components: {
    // 仅在登录情况下激活该插件
    GlobalUploader: () => import("@/views/Common/GlobalUploader"),
    GlobalQueue: () => import("@/views/Common/GlobalQueue"),
  },
  computed: {
    right__folder_tree () {
      return this.$store.getters.right__folder_tree
    },
    right__file_number () {
      return this.$store.getters.right__file_number
    },
    authenticated() {
      return this.$store.state.user.authenticated;
    },
  },
  mounted() {
    this.$router.afterEach(() => {
      window.scrollTo(0, 0);
    });
    // 监听关闭全局组件事件
    Bus.$on("changeGlobalPluginStatus", (param) => {
      this.plugin[param.plugin] = param.status;
    });
    // 监听拖拽事件
    Bus.$on("dragenter", () => {
      if (this.right__folder_tree && this.right__file_number) {
        this.changeDropLayer(true);
      }
    });
    const dropbox = document.getElementById("dropLayer");
    dropbox.addEventListener("dragleave", (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.changeDropLayer(false);
    });
    dropbox.addEventListener("drop", (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.changeDropLayer(false);
    });
  },
  methods: {
    changeDropLayer(status) {
      this.showDropLayer = status;
    },
  },
};
</script>

<style scoped>
#dropLayer {
  font-size: 40px;
  color: rgb(145, 143, 143);
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  border: 2px dashed rgb(145, 143, 143);
  z-index: 8888;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.opacity {
  opacity: 0.5;
}
.global-wraper {
  position: fixed;
  right: 20px;
  bottom: 20px;
  /* box-shadow: 0 2px 10px rgb(0 0 0 / 10%); */
}
</style>

